import { STORES_APP_IDS, STORES_NAMESPACE } from '~/external-ids';
import { SlotContext } from '~/types/common-types';
import { RATING_LIST_WIDGET_ID, RATING_WIDGET_ID, REVIEWS_PLUGGABLE_WIDGET_ID } from '~/app-ids';

export const resolveDefaultNamespace = (
  slotContext: SlotContext | undefined,
  defaultForNonSlot: string,
  widgetId: string,
): string => {
  if (slotContext?.type !== 'slot') {
    return [REVIEWS_PLUGGABLE_WIDGET_ID, RATING_WIDGET_ID, RATING_LIST_WIDGET_ID].includes(widgetId)
      ? STORES_NAMESPACE
      : defaultForNonSlot;
  }

  // For now we just don't want to fail for stores, so all the loose ends are
  // pointed to their namespace
  return !slotContext.appDefinitionId || STORES_APP_IDS.includes(slotContext.appDefinitionId)
    ? STORES_NAMESPACE
    : slotContext.appDefinitionId;
};
